/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Ambient_RegulationInputs */



/**
* | output |
* | --- |
* | "Room regulation" |
*
* @param {Air_Handler_Unit_Ambient_RegulationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_ambient_regulation = /** @type {((inputs?: Air_Handler_Unit_Ambient_RegulationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Ambient_RegulationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Room regulation")
	return /** @type {LocalizedString} */ ("Régulation pièce")
});